import { useMutation } from '@tanstack/react-query'
import { getExportProcessesCsv } from '@/api/processes-api'
import type { PbFindProcessesRequest } from '@itsrever/rever-api'

export const useExportProcessesCsv = () => {
  return useMutation({
    mutationFn: (filters: PbFindProcessesRequest) =>
      getExportProcessesCsv(filters)
  })
}
